import React from "react";
import matchSorter from "match-sorter";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Button from "@material-ui/core/Button/Button";
import AddIcon from "@material-ui/core/SvgIcon/SvgIcon";
import Card from "../../../common/Card";
import ReactTable from "react-table";
import compose from "recompose/compose";
import {withStyles} from "@material-ui/core";
import connect from "react-redux/es/connect/connect";
import {getRaspaRecipes, newRaspaRecipe} from "../../../actions/raspaRecipeActions";

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8,
        width: '100%'
    },
    newRaspaRecipeTooltip: {
        position: 'fixed',
        top: '90vh',
        right: '2vh',
    },
    dense: {
        marginTop: 19,
    },
    menu: {
        width: 200,
    },
});

class RaspaAlarmCountUsageTable extends React.Component {
    constructor(props) {
        super(props);
    };

    componentDidMount() {
    }

    getColumns() {
        return [
            {
                Header: 'Mensagem',
                id: 'mensagem',
                accessor: 'Mensagem',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['mensagem']}),
                filterAll: true,
                minWidth: 300
            },
            {
                Header: 'Uso',
                id: 'uso',
                accessor: 't',
                filterMethod: (filter, rows) =>
                    matchSorter(rows, filter.value, {keys: ['uso']}),
                filterAll: true,
                minWidth: 200
            }

        ];
    }

    render() {
        const { classes, series } = this.props;
        return (
            <React.Fragment>
            <div className={classes.dashboardCardSection}>
                <Card>
                    <ReactTable
                        className="-striped -highlight"
                        columns={this.getColumns()}
                        data={series}
                        defaultPageSize={25}
                        filterable
                        defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value}
                    />
                </Card>
            </div>
        </React.Fragment>
        )
    }
}

export default compose(
    withStyles(styles, {withTheme: true}),
)(RaspaAlarmCountUsageTable)